<template>
    <!-- Sidebar -->
    <div id="sidebar-wrapper">
        <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
            <template v-for="(menuData, index) in $store.getters.menuArr">
                <li v-bind:key="index" :id="menuData.slug" :class="'menuCommon '+menuData.slug">
                    <template v-if="menuData.sub_menu == '' || menuData.sub_menu == null">
                        <template v-if="menuData.url != null && menuData.url != ''">
                            <template v-if="menuData.menu_title.length >= 22">
                                <a :href="menuData.url" target="_blank" v-b-tooltip.hover :title="menuData.menu_title">
                                    <span :class="'spm-nav-menu ' + menuData.icon_url">    
                                </span>
                                {{stringTrim(menuData.menu_title,22)}}
                                </a>
                            </template>
                            <template v-else>
                                <a :href="menuData.url" target="_blank">
                                    <span :class="'spm-nav-menu ' + menuData.icon_url">    
                                </span>
                                {{menuData.menu_title}}
                                </a>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="menuData.menu_title.length >= 22">
                                <router-link v-b-tooltip.hover :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                    <span :class="'spm-nav-menu ' + menuData.icon_url">
                                    </span>{{stringTrim(menuData.menu_title,22)}}
                                </router-link>
                            </template>
                            <template v-else>
                                <router-link v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                    <template v-if="true">
                                        <!-- <template v-if="menuData.menu_title == 'QR Code Scan List'">
                                            <template v-if="loginUserPermission.indexOf('qr_code_scan_list') > -1">
                                                <span :class="'spm-nav-menu ' + menuData.icon_url">
                                                </span>Inventory Scan List
                                            </template>
                                        </template>
                                        <template v-else-if="menuData.menu_title == 'User Management'">
                                            <template v-if="loginUserPermission.indexOf('user_access') > -1">
                                                <span :class="'spm-nav-menu ' + menuData.icon_url">
                                                </span>{{menuData.menu_title}}
                                            </template>
                                        </template>
                                        <template v-else-if="menuData.menu_title == 'QR Code Generate'">
                                            <template v-if="loginUserPermission.indexOf('qr_code_generate') > -1">
                                                <span :class="'spm-nav-menu ' + menuData.icon_url">
                                                </span>{{menuData.menu_title}}
                                            </template>
                                        </template>
                                        <template v-else> -->
                                        <template>
                                            <span :class="'spm-nav-menu ' + menuData.icon_url">
                                            </span>{{menuData.menu_title}}
                                        </template>
                                    </template>
                                    <template v-else>
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">
                                        </span>{{menuData.menu_title}}
                                    </template>
                                </router-link>
                            </template>
                        </template>
                    </template>
                    <template v-else>
                        <template v-if="menuData.url != null && menuData.url != ''">
                            <template v-if="menuData.menu_title.length >= 22">
                                <a v-b-tooltip.hover :title="menuData.menu_title" :href="menuData.url" target="_blank">
                                    <label class="tree-toggle nav-header">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">
                                        </span> {{stringTrim(menuData.menu_title,22)}}
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </label>
                                </a>
                            </template>
                            <template v-else>
                                <a :href="menuData.url" target="_blank">
                                    <label class="tree-toggle nav-header">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">
                                        </span> {{menuData.menu_title}}
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </label>
                                </a>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="menuData.menu_title.length >= 22">
                                <router-link v-b-tooltip.hover :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                    <label class="tree-toggle nav-header">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">
                                        </span> {{stringTrim(menuData.menu_title,22)}}
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </label>
                                </router-link>
                            </template>
                            <template v-else>
                                <router-link v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                    <label class="tree-toggle nav-header">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">
                                        </span> {{menuData.menu_title}}
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </label>
                                </router-link>
                            </template>
                        </template>
                        <ul class="nav nav-list tree">
                            <template v-for="(subMenuData, index1) in menuData.sub_menu">
                                <template v-if="subMenuData.url != null && subMenuData.url != ''">
                                    <li :key="index1" :class="'subMenuLi '+subMenuData.slug">
                                        <template v-if="subMenuData.menu_title.length >= 30">
                                            <a v-b-tooltip.hover :title="subMenuData.menu_title" :href="subMenuData.url" target="_blank">
                                               {{stringTrim(subMenuData.menu_title,30)}}
                                            </a>
                                        </template>
                                        <template v-else>
                                            <a :href="subMenuData.url" target="_blank">
                                                {{subMenuData.menu_title}}
                                            </a>
                                        </template>
                                    </li>
                                </template>
                                <template v-else>
                                    <li :key="index1" :class="'subMenuLi '+subMenuData.slug">
                                        <template v-if="subMenuData.menu_title.length >= 30">
                                            <router-link v-b-tooltip.hover :title="subMenuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                {{stringTrim(subMenuData.menu_title,30)}}
                                            </router-link>
                                        </template>
                                        <template v-else>
                                            <router-link v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                {{subMenuData.menu_title}}
                                            </router-link>
                                        </template>
                                    </li>
                                </template>
                            </template>
                        </ul>
                    </template>
                </li>
            </template>
            <template v-for="(menu, m_index) in menuArray">
                <li v-if="arrayContainsArray(loginUserPermission, menu.permissionName)" v-bind:key="'m menu ' + m_index" :id="menu.slug" :class="'menuCommon '+menu.slug">
                    <template v-if="!menu.SubMenu">
                        <router-link v-bind:to="{name: menu.routerlink.name}">
                            <span :class="'spm-nav-menu ' + menu.icon"></span>
                            {{stringTrim(menu.name, 22)}}
                        </router-link>
                    </template>
                    <template v-if="menu.SubMenu && menu.SubMenu.length > 0">
                        <label class="tree-toggle nav-header">
                            <span :class="'spm-nav-menu ' + menu.icon"></span>
                            {{menu.name}}
                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </label>
                        <ul class="nav nav-list tree">
                            <template v-for="(submenu, sub_index) in menu.SubMenu">
                                <li v-if="arrayContainsArray(loginUserPermission, submenu.permissionName)" :key="'sub ' + sub_index" :class="'subMenuLi '+submenu.slug">
                                    <router-link v-bind:to="{name: submenu.routerlink.name}">
                                        {{stringTrim(submenu.name, 30)}}
                                    </router-link>
                                </li>
                            </template>
                        </ul>
                    </template>
                </li>
            </template>
        </ul>
    </div>
<!-- Sidebar -->
</template>

<script>
    import Vue from 'vue';
    import {HTTP} from '../../http-common.js';
    import EventBus from '.././event-bus';
    var self;

    import {commonMixins} from '../../mixins/commonMixins';

    export default {
        name: 'Center',
        mixins: [commonMixins],
        data() {
            return {
                menuArr: [],
                loginUserPermission: ['qr_code_scan_list', 'user_access', 'qr_code_generate'],
                // loginUserPermission: [],
                menuArray: [
                    {
                        name: "User Management",
                        slug: "user-access",
                        routerlink: {
                            name: "ListUsers"
                        },
                        icon: "icon-procedures",
                        permissionName: ["user_access"]
                    },
                    {
                        name: "Vehicle Tracking",
                        icon: "icon-Sales-9",
                        slug: "vehicle-tracking",
                        permissionName: [
                            "qr_code_generate", "qr_code_scan_list"
                        ],
                        SubMenu: [
                            {
                                name: "QR Code Generate",
                                slug: "qr-code-generate",
                                routerlink: {
                                    name: "GenerateQRCode"
                                },
                                icon: "icon-vtccontact-group",
                                permissionName: ["qr_code_generate"]
                            },
                            {
                                name: "Inventory Scan List",
                                slug: "qr-code-scan-list",
                                routerlink: {
                                    name: "ListQRCodeScan"
                                },
                                icon: "icon-vtccontact-group",
                                permissionName: ["qr_code_scan_list"]
                            },
                        ]
                    }
                ],
            }

        },
        beforeMount: function () {
            // self.loginUserPermission = [];
        },
        mounted: function () {
            self = this;
            $("#menu-toggle").click(function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled");
            });
            $("#menu-toggle-2").click(function (e) {
                //console.log("here");
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled-2");
                $('#menu ul').hide();
            });

            $('.tree-toggle').click(function () {
                $(this).parent().children('ul.tree').toggle(200);
            });

            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                self.$store.dispatch('loadMenu');
            }

        },
        methods: {

        }
    };
    EventBus.$on('reload-menu', function (menuArr) {
        //console.log('Event Called');
        if (typeof (self) != 'undefined') {
            self.$nextTick(() => {
                self.firstLoadMenu();
            });
        }
    });
    EventBus.$on('sidebarPermission', function (loginUserPermission) {
        if (typeof (self) != "undefined") {
            // self.loginUserPermission = loginUserPermission;
            self.loginUserPermission = [];
            for (let i = 0; i < loginUserPermission.length; i++) {
                self.loginUserPermission.push(loginUserPermission[i])
            }
        }
    });
</script>


// WEBPACK FOOTER //
// src/components/partials/Sidebar.vue